import CustomSelect from '../CustomSelect';
import StoryPointsInput from '../StoryPointsInput';
import FormField from '../shared/FormField';
import TypeSelectorButtons from '../shared/TypeSelectorButtons';
import { TYPE_OPTIONS, STATUS_OPTIONS, KANBAN_STATUS_OPTIONS, TYPES_SIMPLE, HIERARCHY_TYPES_SIMPLE, PRIORITY_OPTIONS } from '../../constants';

export function MobileAddFormFields({ form, userOptions, isKanban, allowedTypes }) {
  const typeOptions = allowedTypes
    ? HIERARCHY_TYPES_SIMPLE.filter((t) => allowedTypes.includes(t.value))
    : (isKanban ? TYPES_SIMPLE : HIERARCHY_TYPES_SIMPLE);

  return (
    <>
      <FormField label="Type" className="mobile-input-group" labelClassName="mobile-label">
        <TypeSelectorButtons typeOptions={typeOptions} value={form.type} onChange={form.setType} iconSize={16} wrapperClass="mobile-type-selector" />
      </FormField>
      <FormField label="Title" className="mobile-input-group" labelClassName="mobile-label">
        <input className="mobile-input" value={form.title} onChange={(e) => form.setTitle(e.target.value)} placeholder="Enter title" />
      </FormField>
      <FormField label="Description" className="mobile-input-group" labelClassName="mobile-label">
        <textarea className="mobile-input" rows={2} value={form.desc} onChange={(e) => form.setDesc(e.target.value)} placeholder="Optional" />
      </FormField>
      <FormField label="Story Points" className="mobile-input-group" labelClassName="mobile-label">
        <StoryPointsInput value={form.points} onChange={form.setPoints} placeholder="Optional" />
      </FormField>
      <FormField label="Assign To" className="mobile-input-group" labelClassName="mobile-label">
        <CustomSelect value={form.assignee} onChange={form.setAssignee} options={userOptions} placeholder="Unassigned" />
      </FormField>
      {isKanban && (
        <FormField label="Priority" className="mobile-input-group" labelClassName="mobile-label">
          <CustomSelect value={form.priority} onChange={form.setPriority} options={PRIORITY_OPTIONS} />
        </FormField>
      )}
    </>
  );
}

export function MobileEditFormFields({ form, userOptions, isKanban, children }) {
  return (
    <div className="mobile-form">
      <FormField label="Type" className="mobile-input-group" labelClassName="mobile-label">
        <CustomSelect value={form.type} onChange={form.setType} options={TYPE_OPTIONS} />
      </FormField>
      <FormField label="Title" className="mobile-input-group" labelClassName="mobile-label">
        <input className="mobile-input" value={form.title} onChange={(e) => form.setTitle(e.target.value)} />
      </FormField>
      <FormField label="Description" className="mobile-input-group" labelClassName="mobile-label">
        <textarea className="mobile-input" rows={2} value={form.desc} onChange={(e) => form.setDesc(e.target.value)} />
      </FormField>
      <FormField label="Points" className="mobile-input-group" labelClassName="mobile-label">
        <StoryPointsInput value={form.points} onChange={form.setPoints} />
      </FormField>
      <FormField label="Status" className="mobile-input-group" labelClassName="mobile-label">
        <CustomSelect value={form.status} onChange={form.setStatus} options={isKanban ? KANBAN_STATUS_OPTIONS : STATUS_OPTIONS} />
      </FormField>
      <FormField label="Assign To" className="mobile-input-group" labelClassName="mobile-label">
        <CustomSelect value={form.assignee} onChange={form.setAssignee} options={userOptions} placeholder="Unassigned" />
      </FormField>
      {children}
      {isKanban && (
        <FormField label="Priority" className="mobile-input-group" labelClassName="mobile-label">
          <CustomSelect value={form.priority} onChange={form.setPriority} options={PRIORITY_OPTIONS} />
        </FormField>
      )}
    </div>
  );
}
